import PropTypes from 'prop-types';
export default {
  center: PropTypes.arrayOf(PropTypes.number).isRequired,
  htmlFriendlyDescription: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    src: PropTypes.string.isRequired,
    anchor: PropTypes.arrayOf(PropTypes.number).isRequired,
    anchorXUnits: PropTypes.oneOf(['fraction', 'pixels']),
    anchorYUnits: PropTypes.oneOf(['fraction', 'pixels'])
  })
};